import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { usePersonaStore } from '../../../../../store/usePersonaStore'
import { toneItems } from './content'

const Tone = () => {
  const { toneId, setToneId } = usePersonaStore()

  return (
    <div className="flex flex-col p-[20px]">
      <span className="Headline3-22Bd mb-2">어떤 말투로 대화하나요?</span>

      <FormControl component="fieldset" className="mt-[36px]">
        <RadioGroup
          value={toneId}
          onChange={(e) => setToneId(Number(e.target.value))}
          sx={{
            display: 'grid',
            rowGap: 2,
          }}
        >
          {toneItems.map((option, i) => (
            <FormControlLabel
              key={i}
              value={option.id}
              control={
                <Radio
                  sx={{
                    color: '#C9CCDE',
                    '&.Mui-checked': {
                      color: '#503CC8', // ✅ selected (center dot + border)
                    },
                  }}
                />
              }
              label={
                <div className="flex flex-col mt-[6px]">
                  <Typography className="Title2-18Bd">{option.value}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {option.content}
                  </Typography>
                </div>
              }
              sx={{
                alignItems: 'flex-start', // ✅ aligns radio and label at the top
                margin: 0,
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  )
}

export default Tone
